import { EllipsisVerticalIcon } from "@heroicons/react/24/solid";
import { Skeleton } from "@/core/components/ui/skeleton";
import { Stack } from "@/core/components/ui/stack";
import { Typography } from "@/core/components/ui/typography";
import { formatDate } from "@/core/utils/date";
import { getCustomerNameOrPhone } from "@/customer/utils";
import { ReferralOptionsDropdown } from "@/referrals/common/referral-options-dropdown";
import type { IReferral } from "@/referrals/referral";

interface NameAndDateProps {
  referral: IReferral;
  hideDate?: boolean;
  onLost?: () => void;
  onMoveToPaid?: () => void;
  onDelete?: () => void;
}

export const NameAndDateSkeleton = ({ showDate }: { showDate?: boolean }) => (
  <Stack direction="row" justify="between" align="center" fullWidth>
    <Stack gap="sm">
      {showDate && <Skeleton className="h-3 w-20" />}
      <Skeleton className="h-4 w-36" />
    </Stack>
    <Skeleton className="h-6 w-6 rounded-full" />
  </Stack>
);

export const NameAndDate = ({
  referral,
  hideDate,
  onLost,
  onMoveToPaid,
  onDelete,
}: NameAndDateProps) => (
  <Stack direction="row" justify="between" align="center" fullWidth>
    <Stack gap="sm">
      {!hideDate && (
        <Typography variant="captionW1" textColor="tertiary">
          {formatDate(referral.created_at) || "No Date"}
        </Typography>
      )}
      <Typography variant="subtitleW3">
        {getCustomerNameOrPhone(referral.potential_customer)}
      </Typography>
    </Stack>
    <ReferralOptionsDropdown
      referral={referral}
      onLost={onLost}
      onMoveToPaid={onMoveToPaid}
      onDelete={onDelete}
    >
      <EllipsisVerticalIcon className="text-text-tertiary h-6 w-6" />
    </ReferralOptionsDropdown>
  </Stack>
);
